export const APP_NAME = 'identidades';
